import { useQuery, UseQueryResult } from 'react-query';
import { DocketCase } from '../../models/CompanyDockets';
import { fetchCases } from '../../services/dockets/dockets.service';
import { queryKeys } from '../queryKeyFactory';

const JUDGE_ROLE = 'Judge';

const transformCaseType = (caseType?: string | null): string => {
  switch (caseType) {
    case 'bk': {
      return 'Bankruptcy';
    }
    case 'cv': {
      return 'Civil';
    }
    case 'cr': {
      return 'Criminal';
    }
    case 'ap': {
      return 'Appellate';
    }
    default:
      return 'Other';
  }
};

export default (companyId: string, enabled: boolean): UseQueryResult<DocketCase[], Error> => {
  return useQuery<DocketCase[], Error>(
    queryKeys.dockets.fetchCases.allByIssuer(companyId),
    async () => {
      const docketCases = await fetchCases(companyId);
      return docketCases.map((docketCase) => ({
        id: docketCase.caseId,
        name: docketCase.caseName,
        type: transformCaseType(docketCase.caseType),
        date: docketCase.dateField,
        defaultCase: docketCase.defaultCase,
        caseNumber: docketCase.caseNumber,
        courtName: docketCase.courtName,
        judges: docketCase.parties.filter((party) => party.partyRole === JUDGE_ROLE).map((judge) => judge.partyName),
      }));
    },
    {
      enabled: !Number.isNaN(Number(companyId)) && enabled,
    }
  );
};
